module.exports = __webpack_public_path__ + "static/media/proj15_img12.289f14bd.jpg";